import { create } from "zustand";
import ICoreTenantSettings from "../interfaces/ICoreTenantSettings";

/** CoreAPI tenant settings, loaded at startup. Null until loaded, or when they couldn't be loaded. */
interface TenantSettingsState {
    settings: ICoreTenantSettings | null;

    setSettings: (settings: ICoreTenantSettings | null) => void;
}

export const useTenantSettingsStore = create<TenantSettingsState>()((set) => ({
    settings: null,

    setSettings: (settings) => set({ settings }),
}));
